export default __webpack_public_path__ + "static/media/baby.41490441.svg";